<template>
  <div class="cont">
    <Navbar></Navbar>
    <div class="waterfall_title">
      广场图片配置
      <el-button type="danger" @click="save_square"
        >保存选中图片至广场中</el-button
      >
    </div>
    <waterfall
      :col="7"
      :width="itemWidth"
      :gutterWidth="14"
      :data="imgList"
      :loadDistance="50"
      @loadmore="loadwatermore"
    >
      <template>
        <div
          class="cell-item"
          v-for="(item, index) in imgList"
          :class="{ selected: item.selected }"
          :key="index"
        >
          <img
            :src="item.url"
            class="waterfall-item"
            style="width: 100%"
            @click="addFocus(index)"
          />
          <!-- <div class="item-body">
              <div class="item-desc">{{item.title}}</div>
              <div class="item-footer">
                  <div class="avatar" :style="{backgroundImage : `url(${item.avatar})` }"></div>
                  <div class="name">{{item.user}}</div>
                  <div class="like" :class="item.liked?'active':''" >
                      <i ></i>
                      <div class="like-total">{{item.liked}}</div>  
                  </div>
              </div>
          </div> -->
        </div>
      </template>
    </waterfall>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import common from "../utils/common";
import { square_page_req, img_list_req, save_square_req } from "@/api/square";
import { user_account_req } from "@/api/user";

// @ is an alias to /src

export default {
  name: "SquareConfig",
  components: {
    Navbar,
  },
  data() {
    return {
      navdata: [],
      text: "",
      imgList: [],
      pageNum: 1,
      pageSize: 30,
      isHover: false,
      hoverIdx: undefined,
      selected_arr: undefined,
    };
  },
  computed: {
    itemWidth() {
      return (document.documentElement.clientWidth - 168) / 7 - 15;
    },
  },
  mounted() {
    this.selected_arr = new Set();
    this.navdata = this.$i18n.messages[this.$i18n.locale].getNavData;
    //  this.get_square_page( )
    this.get_img_list();
    this.getUserAccountInfo();
  },
  methods: {
    search_click() {
      this.$router.push({
        name: "aiQa", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
        params: {
          text: this.text,
        },
      });
    },
    img_click() {
      this.$router.push({
        name: "textImage", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
      });
    },
    get_square_page() {
      square_page_req({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        // console.log( res )
        this.imgList = this.imgList.concat(res.data.records);
      });
    },
    get_img_list() {
      img_list_req({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        res.data.records.forEach((element) => {
          element.selected = false;
        });
        this.imgList = this.imgList.concat(res.data.records);
      });
    },
    loadwatermore() {
      this.pageNum++;
      // this.get_square_page();
      this.get_img_list();
    },

    addFocus(index) {
      if (
        this.imgList[index].selected &&
        this.imgList[index].selected == true
      ) {
        this.imgList[index].selected = false;
      } else {
        this.imgList[index].selected = true;
      }
    },
    async save_square() {
      let arr = [];
      this.imgList.forEach((val) => {
        if (val.selected) {
          val.selected = undefined;
          arr.push(val);
        }
      });
      const { success } = await save_square_req(arr);
      if (success) {
        this.$toast.open({
          message: "保存成功",
          position: "top",
          duration: 3000,
          type: "success",
        });
      }
    },
    async getUserAccountInfo() {
      const { data, success } = await user_account_req();
      if (success) {
        if (data.ext) {
          data.ext = JSON.parse(data.ext);
          if (data.ext && data.ext.role && data.ext.role == "admin") {
            return;
          } else {
            this.$router.replace({ path: "/" });
          }
        }
      }
      this.$router.replace({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .form-control {
  border: none;
}
::v-deep .form-control:focus {
  border-color: #fff;
  box-shadow: none;
}
.cont {
  padding: 60px 84px 0;
  // height: calc(100% );
  box-sizing: border-box;
}
.row {
  margin-left: 0;
  margin-right: 0;
}

.icon {
  width: 40%;
  min-width: 70px;
  min-height: 70px;
  padding-bottom: 40%;
  margin: 0 auto;
}

.home1 {
  margin-top: 77px;
  justify-content: center;
  align-items: center;
  font-size: 32px;
  color: #fff;
}

.home2 {
  margin-top: 42px;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;

  .item {
    box-sizing: border-box;
    height: 40px;
    width: 96px;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
  }
  .active {
    background-color: #fff;
    color: #fff;
    font-weight: 500;
    height: 40px;
    width: 96px;
    background: #222337;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    margin-right: 102px;
  }
}

.home3 {
  width: 1000px;
  justify-content: center;
  align-items: center;
  color: #fff;
  height: 66px;
  border-radius: 33px;
  background-color: #222337;
  margin: 24px auto 20px;
  .l {
    justify-content: center;
    align-items: center;
    width: 72px;
    height: 66px;
  }
  .input {
    background-color: #222337;
    color: #fff;
    padding: 0;
  }
  .input::placeholder {
    color: #49495a;
  }

  .search-btn {
    height: 66px;
    width: 92px;
    align-items: center;
    justify-content: center;
  }
}

.waterfall_title {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 33px;
  margin-top: 43px;
  margin-bottom: 16px;
}
.cell-item {
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 14px;
  position: relative;
  .btn {
    display: none;
  }
  .selected_icon {
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 999;
    color: orange;
  }
}
.cell-item.selected {
  border: 5px solid orange;
}

.cell-item:hover img {
  transform: scale(1.15);
}
.cell-item:hover {
  .btn {
    display: block;
    position: absolute;
    top: 16px;
    right: 16px;
    width: 66px;
    height: 34px;
    line-height: 34px;
    background: #006fff;
    border-radius: 17px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    padding: 0;
  }
}
</style>
